import SectionHeader from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import {
    CAROUSEL_ITEM_HEADER_HEIGHT,
    CAROUSEL_ITEM_PADDING,
    SectionLayoutProps
} from "./SectionLayout.constants";
import VariantWrapper from "./VariantWrapper";
import SectionMedia from "./SectionMedia";
import { GradualSpacing } from '../../../effects/GradualSpacing';

function SectionLayoutVariant4(props: SectionLayoutProps) {
    const {
        headerSettings,
        section,
        isEntrySection,
    } = props;
    const {
        media,
        title,
    } = section;

    return (
        <VariantWrapper section={section}>
            <TextWrapper style={{ color: 'white' }} initial={isEntrySection}>
                <SectionHeader {...headerSettings} />
            </TextWrapper>

            <TextWrapper
                style={{
                    color: 'white',
                    padding: `2.6vh ${CAROUSEL_ITEM_PADDING}vh 5.21vh ${CAROUSEL_ITEM_PADDING}vh`,
                    top: `${CAROUSEL_ITEM_HEADER_HEIGHT}vh`,
                    left: 0,
                    fontSize: '7.55vh', // 145
                    lineHeight: '8.31vh', // 159.50px
                    textTransform: 'uppercase',
                    fontFamily: 'HelveticaNowDisplay',
                    fontWeight: '500',
                }}
            >
                <GradualSpacing text={title} offset={1} />
            </TextWrapper>

            <SectionMedia
                style={{ position: 'absolute', zIndex: -10, filter: 'brightness(0.6)' }}
                media={media}
            />
        </VariantWrapper>
    )
}

export default SectionLayoutVariant4;
